import {fetch} from 'core/util';

import {getEndpoint} from './util';

const getConfig = () => fetch.doGet(getEndpoint('/api/config'), false);

export const configApi = {
    getConfig,
};
